
import { useCallback, useRef } from 'react';
import { AdminState, AdminAction } from '@/types/adminTypes';

/**
 * Hook to handle data refresh functionality for admin activity
 */
export const useAdminActivityRefresh = (
  loadState: () => Promise<AdminState>,
  loadAdminActions: () => Promise<AdminAction[]>,
  setIsLoading: (isLoading: boolean) => void
) => {
  // Combined refresh function for both state and actions
  const refreshAdminData = useCallback(async () => {
    try {
      const state = await loadState();
      const actions = await loadAdminActions();
      
      setIsLoading(false);
      return { actions, state };
    } catch (error) {
      console.error('Error refreshing admin data:', error);
      setIsLoading(false);
      
      const state = await loadState();
      const actions = await loadAdminActions();
      
      return { actions, state };
    }
  }, [loadState, loadAdminActions, setIsLoading]);

  return {
    refreshAdminData
  };
};
